export default __webpack_public_path__ + "static/media/insta16.e18d7157.webp";